var React = require('react');

function Hamby1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44837","data-name":"Group 44837","transform":"translate(-373 -23)"},React.createElement("path",{"id":"plus-r","d":"M11.25,12.75v7h1.5v-7h7v-1.5h-7v-7h-1.5v7h-7v1.5Z","fill":"currentColor","transform":"translate(384 17.069) rotate(45)"})));
}

Hamby1.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Hamby1;

Hamby1.default = Hamby1;
